import React from 'react';
import PropTypes from 'prop-types';
import {Container, PopupElement, Element, ContentContainer} from './context_menu.styled';

export const ContextMenu = ({children, onClick, minWidth}) => {
	const handleOnClick = (value, disabled) => {
		if (!disabled) {
			onClick(value);
		}
	};
	return (
		<Container minWidth={minWidth}>
			<ContentContainer>
				{React.Children.map(children, child => {
					const {value, disabled} = child.props;
					return (
						<PopupElement onClick={() => handleOnClick(value, disabled)} disabled={disabled}>
							<Element>{child}</Element>
						</PopupElement>
					);
				})}
			</ContentContainer>
		</Container>
	);
};

ContextMenu.propTypes = {
	children: PropTypes.node,
	onClick: PropTypes.func,
	minWidth: PropTypes.number,
};

ContextMenu.defaultProps = {
	onClick: () => false,
};
